export default __webpack_public_path__ + "static/media/Chris_Hk.f850a5f7.webp";